import { useEffect } from 'react';

var useFullscreenModal = function useFullscreenModal(isShown) {
  useEffect(function () {
    if (isShown) {
      document.body.style.top = "-".concat(window.scrollY, "px");
      document.body.style.position = 'fixed';
    } else {
      var scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }
  }, [isShown]);
};

export default useFullscreenModal;